import { DocumentReadModes } from "@app/enums/DocumentReadModes"
import LocalStorage from "./LocalStorage"
import SessionStorage from "./SessionStorage"

export default class PhotoHelper {

  public static NeedSelfie() :boolean {
        if (LocalStorage.IsTabletMode) {
          if (LocalStorage.OperationMode == 'VIP') {
            return SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_AND_SELFIE
    
          } else {
            return SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_AND_SELFIE
          }
        } else {
          return  SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_AND_SELFIE
        }
    
  }
}